// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__u1fe3","tab":"Tabs_tab__1uP6i","tabActive":"Tabs_tabActive__33KCQ"};